"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchStudents = exports.fetchConfig = void 0;
var headers = {
    'Content-Type': 'application/json',
    'X-WP-Nonce': window.ChongerApiSettings.nonce,
};
var fetchConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(ChongerApiSettings.root + "config", {
                    headers: headers,
                })
                    .then(function (res) { return res.json(); })
                    .then(function (json) {
                    return json;
                })
                    .catch(function (error) { })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.fetchConfig = fetchConfig;
var fetchStudents = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(window.ChongerApiSettings.root + "search", {
                    method: 'POST',
                    credentials: 'include',
                    headers: headers,
                    body: JSON.stringify(data),
                })
                    .then(function (resp) { return resp.json(); })
                    .then(function (resp) {
                    return resp;
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.fetchStudents = fetchStudents;
/*
export const fetchBelts = async (studentID: number) => {
    return await fetch(`${ChongerApiSettings.root}category?user=${studentID}`, {
        headers,
    })
        .then((res) => res.json())
        .then((json) => {
            return json
        })
        .catch((error) => {})
}

export const fetchChallenges = async (categoryID: string, header: Record<string, unknown> = {}) => {
    const studentID = new URLSearchParams(location.search).get('user')
    const qs = `?category=${categoryID}` + (studentID ? `&student=${studentID}` : '')

    return await fetch(`${ChongerApiSettings.root}challenge/${qs}`, {
        headers,
        ...header,
    })
        .then((res) => res.json())
        .then((json) => {
            return json
        })
        .catch((error) => {})
}

export const fetchChallengeReview = async (challengeID: number) => {
    return await fetch(`${window.ChongerApiSettings.root}review/${challengeID}`, {
        method: 'GET',
        credentials: 'include',
        headers,
    })
        .then((resp) => resp.json())
        .then((resp) => {
            return resp
        })
}

export const addChallenge = async (data: Record<string, unknown>, challengeID: number) => {
    return await fetch(`${window.ChongerApiSettings.root}challenge/${challengeID}`, {
        method: 'POST',
        credentials: 'include',
        headers,
        body: JSON.stringify(data),
    })
        .then((resp) => resp.json())
        .then((resp) => {
            return resp
        })
}

export const fetchVideo = async (query: string, page: number, interval: number) => {
    return await fetch(`${window.ChongerApiSettings.root}video?q=${query}&p=${page}&interval=${interval}`, {
        credentials: 'include',
        headers,
    }).then((resp) => resp.json())
}

export const fetchVideoData = async (id: Array<string> | number) => {
    const qs = '?' + (typeof id === 'object' ? 'ids=' + id.join(',') : `id=${id}`)

    return await fetch(`${window.ChongerApiSettings.root}video/${qs}`, {
        method: 'GET',
        credentials: 'include',
        headers,
    })
        .then((resp) => resp.json())
        .then((resp) => {
            return resp
        })
}

export const fetchLabels = async () => {
    return await fetch(`${window.ChongerApiSettings.root}/labels`, {
        credentials: 'include',
        headers,
    })
        .then((resp) => resp.json())
        .then((resp) => {
            return resp
        })
}
*/
